import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
`;
